import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'OperationTypeDMS/GetAllOperationDMSTypes', method: 'GET', body: null, token: token })
}
